import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getCategoryAll = (_params, onSuccess, onError) => {
    const response = axios.get('v1/admin/category', { params: _params });
    return handleResponse(response, onSuccess, onError);
};

export const getCategoryById = (id, onSuccess, onError) => {
    const response = axios.get(`v1/admin/category/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const createCategory = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/admin/category`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const updateCategory = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/category/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const softDeleteCategory = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/category/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const deleteCategory = (id, onSuccess, onError) => {
    const response = axios.delete(`v1/admin/category/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const getCategoryWithChildrenAll = (_params, onSuccess, onError) => {
    const response = axios.get('v1/admin/category-childrens', { params: _params });
    return handleResponse(response, onSuccess, onError);
};